module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "warnings",
    class: {
      'warnings_icon': !_vm.isHeader
    }
  }, [(_vm.isHeader) ? _c('h3', {
    staticClass: "warnings__heading",
    class: {
      'warnings__heading_icon': _vm.$slots.default
    }
  }, [_vm._t("heading", [_vm._v("Тут пока пусто")])], 2) : _vm._e(), _vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-442868e8","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/components/warning/Warning.vue
// module id = 9104032c47d824431fec
// module chunks = 89